export * from '@core/components/fullscreen/public-api';
